export enum PersonalInformationFieldNames {
  Civility = 'civility',
  FirstName = 'firstName',
  LastName = 'lastName',
  BirthName = 'birthName',
  BirthDate = 'birthDate',
  Nationality = 'nationality',
  BirthCountry = 'birthCountry',
  Email = 'email',
  Phone = 'phone',
  TaxResidenceCountryId = 'taxResidenceCountryId',
  IsPPE = 'isPPE',
  IsFPE = 'isFPE'
}
